import { CardLoader, ListPagination } from 'components/organisms'
import withLoader from 'hocs/with-loader'
import PropTypes from 'prop-types'
import React from 'react'
import { Table } from 'reactstrap'
import SellerInboundUrlParamsTableRow from './seller-inbound-url-params-table-row'
import { SELLER_INBOUND_COLUMNS, SELLER_COLUMNS, CURATION_COLUMNS } from './seller-inbound-url-params-table-columns'

const propTypes = {
  tableProps       : PropTypes.object,
  inbounds         : PropTypes.array,
  pagination       : PropTypes.object,
  onPageChange     : PropTypes.func,
  isLoading        : PropTypes.bool,
  to               : PropTypes.func,
  onSelectRow      : PropTypes.func,
  hiddenColumns    : PropTypes.array,
  actionButtonText : PropTypes.string
}

const defaultProps = {
  isLoading        : true,
  onPageChange     : () => { },
  hiddenColumns    : [],
  actionButtonText : 'Detail'
}

/**
 * Table to display specific ::Seller::Inbound data
 * @param {Object} tableProps - object of tableProps that contains size, responsive, etc
 * @param {Array<Object>} inbounds - array of Seller::Inbound
 * @param {Object} pagination - object of pagination data from endpoint
 * @param {Boolean} isLoading - boolean for withLoader animation
 * @param {Function} onPageChange - function that will handle page change
 * @param {String} to - Link to navigate if user click on action button
 * @param {Function} onSelectRow - function that trigger when user click action button
 * @param {Array<String>} hiddenColumns - Array of hidden columns name
 * @param {String} actionButtonText - Action button text/label
 */
const SellerInboundUrlParamsTable = ({
  tableProps,
  inbounds,
  pagination,
  isLoading,
  onPageChange,
  to,
  onSelectRow,
  hiddenColumns,
  actionButtonText
}) => {

  const sellerInboundColumns = SELLER_INBOUND_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))
  const sellerColumns        = SELLER_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))
  const curationColumns      = CURATION_COLUMNS.filter((column) => !hiddenColumns.includes(column.name))

  const sellerInboundHeaderLength = sellerInboundColumns.length
  const sellerHeaderLength        = sellerColumns.length
  const curationHeaderLength      = curationColumns.length

  const totalColumns    = sellerInboundHeaderLength + sellerHeaderLength + curationHeaderLength
  const isInboundsEmpty = inbounds.length === 0

  const TableContent = () => (
    <>
      <Table { ...tableProps }>
        <thead>
          <tr>
            {
              sellerInboundHeaderLength > 0 && (
                <th colSpan={ sellerInboundHeaderLength } className='text-center'>
                  { 'Seller Inbound' }
                </th>
              )
            }
            {
              curationHeaderLength > 0 && (
                <th colSpan={ curationHeaderLength } className='text-center'>
                  { 'Curation' }
                </th>
              )
            }
            {
              sellerHeaderLength > 0 && (
                <th colSpan={ sellerHeaderLength } className='text-center'>
                  { 'Seller' }
                </th>
              )
            }
          </tr>
        </thead>
        <thead>
          <tr>
            {
              sellerInboundColumns.map((column) => (
                <th key={ `inbound-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
            {
              curationColumns.map((column) => (
                <th key={ `inbound-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
            {
              sellerColumns.map((column) => (
                <th key={ `inbound-column-${column.name}` } scope="col">{ column.label }</th>
              ))
            }
          </tr>
        </thead>
        <tbody>
          {
            inbounds.map((inboundData) => (
              <SellerInboundUrlParamsTableRow
                key={ `seller-inbound-data-${inboundData.id}` }
                inbound={ inboundData }
                to={ to }
                onSelectRow={ onSelectRow }
                hiddenColumns={ hiddenColumns }
                sellerInboundColumns={ sellerInboundColumns }
                sellerColumns={ sellerColumns }
                curationColumns={ curationColumns }
                actionButtonText={ actionButtonText }
              />
            ))
          }
          {
            isInboundsEmpty && (
              <tr>
                <td
                  colSpan={ totalColumns }
                  className='bg-warning text-white'
                >
                  <i className='fas fa-info-circle mr-3' />
                  { 'Seller Inbounds tidak ditemukan.' }
                </td>
              </tr>
            )
          }
        </tbody>
      </Table>
    </>
  )

  const TableContentWithLoader = withLoader(TableContent, CardLoader)

  return (
    <>
      <TableContentWithLoader isLoading= { isLoading } />

      <ListPagination
        onClickPage={ onPageChange }
        pagination={ pagination }
      />
    </>
  )
}


SellerInboundUrlParamsTable.propTypes    = propTypes
SellerInboundUrlParamsTable.defaultProps = defaultProps

export default SellerInboundUrlParamsTable